import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FocusTrapCallout, Text, Stack, DirectionalHint, DefaultButton, PrimaryButton } from '@bingads-webui-react/fabric-control';
import { withLock, keyVault, priorityLevel } from '@bingads-webui-react/popup-manager';

const styles = {
  teachingBubble: 'recommendation-teaching-bubble',
  header: 'header',
  title: 'title',
  inner: 'inner',
  subtext: 'subtext',
  buttons: 'buttons',
  primaryButton: 'primary-button',
  secondaryButton: 'secondary-button',
  pageIndex: 'page-index',
  footer: 'footer',
  textStyle: {
    root: [
      {
        color: '#ffffff',
      },
    ],
  },
};

class TeachingBubble extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
    pageIndex: PropTypes.number,
    pageCount: PropTypes.number,
    primaryButtonContent: PropTypes.string.isRequired,
    secondaryButtonContent: PropTypes.string,
    target: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    primaryButtonAction: PropTypes.func.isRequired,
    secondaryButtonAction: PropTypes.func,
    children: PropTypes.node.isRequired,
    withPages: PropTypes.bool,
    directionalHint: PropTypes.number,
    withCloseButton: PropTypes.bool,
    name: PropTypes.string,
    doNotLayer: PropTypes.bool,
  };

  static defaultProps = {
    secondaryButtonContent: null,
    secondaryButtonAction: () => null,
    withPages: true,
    withCloseButton: true,
    pageIndex: 0,
    pageCount: 0,
    directionalHint: DirectionalHint.bottomLeftEdge,
    name: '',
    doNotLayer: false,
  };

  onCalloutDismiss = (event) => {
    if (event && event.keyCode === 27) {
      // keyboard ESC click
      this.props.onDismiss();
    }
  };

  preventDismissOnEvent = (event) => {
    if (event && event.type === 'scroll') {
      // When grid table render, it will trigger resize, which will cause teaching bubble dismiss.
      // Add this check to prevent this dismiss.
      return true;
    }
    return false;
  };

  render() {
    const {
      title,
      pageIndex,
      pageCount,
      primaryButtonContent,
      secondaryButtonContent,
      target,
      onClose,
      primaryButtonAction,
      secondaryButtonAction,
      children,
      i18n,
      withPages,
      directionalHint,
      withCloseButton,
      name,
      doNotLayer,
    } = this.props;


    return (
      <FocusTrapCallout
        className={classNames(styles.teachingBubble, name)}
        target={target}
        directionalHint={directionalHint}
        doNotLayer={doNotLayer}
        onDismiss={this.onCalloutDismiss}
        preventDismissOnEvent={this.preventDismissOnEvent}
        focusTrapProps={{
          isClickableOutsideFocusTrap: true,
        }}
        disableFirstFocus
      >
        <div className={styles.header}>
          <Text className={styles.title} styles={styles.textStyle}>{title}</Text>
        </div>
        <div className={styles.inner}>
          <div>
            <Text className={styles.subtext} styles={styles.textStyle}>
              {children}
            </Text>
          </div>
        </div>
        <div className={styles.footer}>
          <Stack className={styles.buttons} gap={8} horizontal>
            <DefaultButton
              onClick={primaryButtonAction}
            >
              {primaryButtonContent}
            </DefaultButton>
            {secondaryButtonContent &&
              <PrimaryButton
                onClick={secondaryButtonAction}
              >
                {secondaryButtonContent}
              </PrimaryButton>}
          </Stack>
          {withPages &&
            <div className={styles.pageIndex}>
              <span>{pageIndex} </span>
              <span>{i18n.getString(_TL_('of'))}</span>
              <span> </span>
              <span>{pageCount}</span>
            </div>
          }
        </div>
        {withCloseButton &&
          <button
            className="closeimage"
            aria-label={i18n.getString(_TL_('Close'))}
            onClick={onClose}
          />
        }
      </FocusTrapCallout>
    );
  }
}

export const TeachingBubbleWithLock = withLock(TeachingBubble, {
  lockKey: keyVault.teachingBubble,
  priority: priorityLevel.teachingBubble,
  autoClose: true,
});
